var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ida-page-403',{attrs:{"locale":_vm.locale,"product":"LIVEBLOG"}})
}
var staticRenderFns = []

export { render, staticRenderFns }